<!-- =========================================================================================
  File Name: notification.vue
  Description: Setting Notification
========================================================================================== -->

<template>
  <div id="setting-notification">
    <div class="vx-row">
      <div class="vx-col md:w-1/4 w-full mb-base" v-for="(item, index) in setting" :key="index">
      	<vx-card :title="item.name">
          <div class="vx-row">
            <div class="vx-col md:w-1/3" v-if="typeof item.switch !== 'undefined'">
              <div class="vs-input--label mb-1">开关</div>
              <vs-switch v-model="item.switch" />
            </div>
            <div class="vx-col md:w-1/3" v-if="typeof item.limit !== 'undefined'">
              <div class="vs-input--label mb-1">额度</div>
              <vs-input v-model="item.limit" class="w-full" />
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <vs-button color="primary" type="filled" @click="submit">提交</vs-button>
  </div>
</template>

<script>

export default {
  data() {
    return {
      setting: {}
    }
  },
  methods: {
    submit () {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.data = JSON.stringify(this.setting)
      this.$utils.post('setting-notificationDo', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
      })
    }
  },
  mounted () {
    // 读取设置
    this.$utils.post('setting-notification', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.setting = res
    })
  }
}
</script>
